"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = exports.libs = exports.api = void 0;
const api_1 = __importDefault(require("./api"));
const libs_1 = __importDefault(require("./libs"));
const types_1 = __importDefault(require("./types"));
// import redux from './redux'
exports.api = api_1.default;
exports.libs = libs_1.default;
exports.types = types_1.default;
exports.default = {
    api: api_1.default,
    libs: libs_1.default,
    types: types_1.default,
};
//# sourceMappingURL=index.js.map